import BaggageIcon from 'components/Icons/BaggageIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type ErrorProps = {
  isDeactivate: boolean;
};

export const ErrorSummary = ({ isDeactivate }: ErrorProps) => {
  const navigate = useNavigate();

  const { t } = useTranslation(['history', 'beneficiaries']);

  const redirectToCreateBatch = () => {
    if (isDeactivate) {
      navigate('?m=dropdown-modal-deactivate');
      return;
    }

    navigate('?m=dropdown-modal-include');
  };

  return (
    <div className="processing-wrapper">
      <BaggageIcon />
      <span>{t('error_processing')}</span>
      <span>{t('error_processing_text')}</span>
      <div className="button-container">
        <button type="button" className="reimport-button" onClick={redirectToCreateBatch}>
          {t('reimport')}
        </button>
      </div>
    </div>
  );
};
